import axios from 'axios';
import meta from '../../data/meta.json';

const { apiUrl } = meta;

const config = {
    baseURL: process.env.NODE_ENV === 'production' ? apiUrl : 'http://localhost:3000/api'
};

const api = axios.create(config);

export const getResultImg = (score) => new Promise((resolve, reject) => {
    api.get(`/result?score=${score.score}`).then(
        (response) => {
            resolve(response.data);
        },
        () => {
            reject(new Error('This image does not exist'));
        }
    )
        .catch(() => {
            reject(new Error('This image does not exist'));
        });
});

export const uploadResultImg = (img, score) => new Promise((resolve, reject) => {
    const fd = new FormData();

    fd.append('image', img, `${score.score}.png`);
    fd.append('score', score.score);

    api.post('/result', fd).then(
        (response) => {
            resolve(response.data);
        },
        (e) => {
            reject(new Error(`Failed to upload the image with an error ${e}`));
        }
    )
        .catch((e) => {
            reject(new Error(`Failed to upload the image with an error ${e}`));
        });
});

export const getLeaderboards = () => new Promise((resolve, reject) => {
    api.get('/leaderboards').then(
        (response) => {
            resolve(response.data);
        },
        (err) => {
            reject(new Error(err));
        }
    )
        .catch((err) => {
            reject(err);
        });
});

export const sendResult = (data) => new Promise((resolve, reject) => {
    api.post('/add-session', data).then(
        (response) => {
            resolve(response.data);
        },
        (err) => {
            reject(new Error(err));
        }
    )
        .catch((err) => {
            reject(err);
        });
});
